import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorSketchInputComponent } from './color-sketch-input.component';
import {
  DxButtonModule,
  DxPopoverModule,
  DxScrollViewModule,
  DxTextBoxModule,
  DxTooltipModule,
} from 'devextreme-angular';
import { ColorSketchModule } from 'ngx-color/sketch';
import { ColorSketchPopoverComponent } from './color-sketch-popover/color-sketch-popover.component';
import { ColorSketchPopoverCssVarsParserPipe } from './color-sketch-popover/color-sketch-popover-css-vars-parser.pipe';
import { ColorSketchInputVarNamePipe } from './color-sketch-input-var-name.pipe';

@NgModule({
  imports: [
    CommonModule,
    DxTextBoxModule,
    ColorSketchModule,
    DxPopoverModule,
    DxButtonModule,
    DxScrollViewModule,
    DxTooltipModule,
  ],
  declarations: [
    ColorSketchInputComponent,
    ColorSketchPopoverComponent,
    ColorSketchPopoverCssVarsParserPipe,
    ColorSketchInputVarNamePipe,
  ],
  exports: [ColorSketchInputComponent, ColorSketchPopoverComponent],
  providers: [],
})
export class ColorSketchInputModule {}
